import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '@/components/LoginPage.vue';
import HomePage from '@/components/HomePage.vue';
import AllPlan from '@/components/AllPlan.vue';

const routes = [
    {
      path: '/',
      name: 'Home',
      component: LoginPage
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage
    },
    {
      path: '/AllPlan',
      name: 'AllPlan',
      component: AllPlan
    },
    {
      path: '/home',
      name: 'HomePage',
      component: HomePage
    }
]
  
const router = createRouter({
    history: createWebHistory(),
    routes
})
 
// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
// router.beforeEach((to, from, next) => {
//   if (to.path === '/login') {
//     next();
//   } else {
//     let token = localStorage.getItem('Authorization');
 
//     if (token === null || token === '') {
//       next('/login');
//     } else {
//       next();
//     }
//   }
// });


export default router;
